module.exports = __webpack_public_path__ + "media/images/emblems/Zeneggen-ed9b5a5ccc26af3b3f055f90d2cf90ce.png";